/* eslint-disable */
import { useState } from 'react';
import ValuateNavbar from '../../components/ValuatorNavbar';
import '../../Styles/ValuatorStyles/ValuatorHome.css';
import useNavigation from '../../hooks/useNavigation';
import CustomerSatisfactionGauge from '../../components/ValuateHomeComponents/CustomerStatisfactionGauge';
import { generatePDF } from '../../utilities/pdfUtils';
import useFetchCompanyId from '../../hooks/CompanyHooks/useFetchCompanyId';
import { db } from '../../firebase-config';
import { collection, query, where, getDocs, getDoc, doc } from 'firebase/firestore';
import MonthPicker from '../../components/MonthlyReportComponents/MonthPicker';
import { calculateAverageRatingsForWorker } from '../../utilities/caseUtils';
import { useSelectedCompany } from '../../contexts/SelectedCompanyContext';
import AdminDropdown from '../../components/AdminDropDown';
import useFetchCompanies from '../../hooks/useFetchCompanies';


function ValuatorHome() {
    const { navigateTo } = useNavigation();
    const { selectedCompany, setSelectedCompany } = useSelectedCompany();
    const { companyId } = useFetchCompanyId(selectedCompany);
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const { companies, isLoading: isCompaniesLoading, error: companyError } = useFetchCompanies();

    const handleDateChange = (adjustedStartDate, adjustedEndDate, startDate, endDate) => {
        setSelectedStartDate(startDate);
        setSelectedEndDate(endDate);
    };
    const handlePDFGeneration = async () => {
        const monthYear = formatMonthYear(selectedStartDate);
        const cases = await fetchCasesForMonth(monthYear);
        if (!cases || cases.length === 0) {
          alert(`Ingen sager fra ${monthYear}`);
          return;
        }
        
        const workerIds = getUniqueWorkerIds(cases);
        console.log(workerIds)
        const workers = await fetchWorkersDetails(workerIds);
        const workersData = prepareWorkersDataForPDF(workers, cases);
        generatePDF(workersData, monthYear);
      };
      
      
      const fetchCasesForMonth = async (monthYear) => {
        const [month, year] = monthYear.split('-').map(Number);
        const startDate = new Date(year, month - 1, 1);
        const endDate = new Date(year, month, 1);
      
        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
          console.error("Invalid date range in fetchCasesForMonth");
          return [];
        }
        const casesRef = collection(db, `/companies/${companyId}/cases`);
        const casesQuery = query(casesRef,
          where('timestamp', '>=', startDate),
          where('timestamp', '<', endDate)
        );
      
        const querySnapshot = await getDocs(casesQuery);
        const cases = [];
        querySnapshot.forEach(doc => {
          cases.push({ id: doc.id, ...doc.data() });
        });
      
        console.log("Fetched cases:", cases);
        return cases;
      };
      
    
    const getUniqueWorkerIds = (cases) => {
        const workerIds = new Set();
        if (Array.isArray(cases)) {
          cases.forEach(caseItem => {
            if (Array.isArray(caseItem.attachedWorkers)) {
              caseItem.attachedWorkers.forEach(workerId => {
                workerIds.add(workerId);
              });
            }
          });
        }
        return Array.from(workerIds);
      };
      
      
      const fetchWorkersDetails = async (workerIds) => {
        const workers = [];
        for (const workerId of workerIds) {
          const workerRef = doc(db, "users", workerId);
            const docSnapshot = await getDoc(workerRef);
            if (docSnapshot.exists()) {
                const workerData = { id: workerId, ...docSnapshot.data() };
                workers.push(workerData);
            }
        }
        return workers;
    };
    
      
      
      const prepareWorkersDataForPDF = (workers, cases) => {
        return workers.map(worker => {
          const workerRatings = calculateAverageRatingsForWorker(worker.id, cases);
          return {
            name: worker.name,
            ratings: workerRatings
          };
        });
      };
      
      

    return(
    <>
        <ValuateNavbar />
        <div className='container valuator-home-container'>
        <h1 className="main-header">Dashboard</h1>
        <AdminDropdown
          allCompanies={companies}
          setSelectedCompany={setSelectedCompany}
          selectedCompany={selectedCompany}>            
          </AdminDropdown>
            <div className='valuator-home-content-container'>
            <h1 className="sub-header">Sager og Medarbejdere</h1>
                <button className="case-btn" onClick={() => navigateTo('/valuator/cases')}>Se Aktuelle sager</button>
                <button className="case-btn" onClick={() => navigateTo('/valuator/archived-cases')}>Se Arkiveret sager</button>
                <button className="case-btn" onClick={() => navigateTo('/valuator/workers')}>Medarbejdere</button>
                </div>
                <div className='valuator-home-content-container'>
                  <h3 className='sub-header'>Genere Månedsrapport på alle medarbejdere</h3>
                <div className="month-picker-container">
                        <p className="month-text">Vælg Måned</p>
                        <MonthPicker
                            selectedDate={new Date(selectedStartDate)}
                            onDateChange={handleDateChange}
                            currentDate={new Date()}
                        />
                    </div>
                <button onClick={handlePDFGeneration}>Byg Måneds Ratings PDF</button>
                </div>
                <div className='valuator-home-content-container'>
                <CustomerSatisfactionGauge companyId={companyId}/>
                </div>
        </div>
    </>
    )
}
export default ValuatorHome;
const formatMonthYear = (date) => {
    if (date instanceof Date) {
        return `${date.getMonth() + 1}-${date.getFullYear()}`;
    } else {
        console.error("Invalid date object provided to formatMonthYear");
        return "";
    }
};
